/* eslint-disable @typescript-eslint/no-explicit-any */
import { Theme } from '@mui/material';
import { GridEventListener } from '@mui/x-data-grid-premium';

// interface DataGridStylesProps {
//  onRowClick?: GridEventListener<'rowClick'> | undefined;
//  onCellClick?: GridEventListener<'cellClick'> | undefined;
//  sx?: Array<any> | object;
// }

const dataGridStyles = (props?: Theme) => ({
 //  ...props?.sx,
 '&.MuiDataGrid--isPro': {
  '& .MuiDataGrid-footerContainer .MuiTablePagination-select.MuiSelect-root': {
   margin: '16px',
  },
  '& .MuiDataGrid-footerContainer .MuiTablePagination-select.MuiSelect-select':
   {
    minWidth: '12px',
    padding: '0 32px 0 4px',
   },
 },
 borderRadius: 0,
 border: 'none',
 '--DataGrid-containerBackground': `${props?.palette.kemek.white}`,

 '&.MuiDataGrid-root--densityCompact': {
  '& .MuiDataGrid-cell': {
   padding: '7px 12px',
   // display: 'flex',
  },
  '& .MuiDataGrid-footerContainer': {
   minHeight: '64px',
  },
 },
 '& .MuiDataGrid-main': {
  background: props?.palette.kemek.white,
 },
 '& .MuiDataGrid-topContainer': {
  zIndex: 5,
 },
 '& .MuiDataGrid-container--top[role=row]': {
  background: 'red',
 },
 '& .MuiDataGrid-columnHeaders': {
  borderRadius: 0,
  borderTop: '1px solid',
  borderColor: props?.palette.kemek.lightestGray,
  background: '#D6ECF8',
  // minHeight: '34px !important',
  // maxHeight: '34px !important',
  // lineHeight: '34px !important',
 },
 '& .MuiDataGrid-columnHeader': {
  padding: ' 0 12px',
  '& .MuiBadge-badge': {
   background: props?.palette.kemek.blue,
   display: 'inline-flex',
   alignItems: 'center',
   justifyContent: 'center',
   width: '20px',
   height: '20px',
   lineHeight: '18px',
   color: 'white',
   fontSize: 10,
   fontWeight: 500,
   padding: 0,
   borderRadius: '50%',
   transform: 'translate(15%, -15%)',
  },
 },
 '& .MuiDataGrid-headerFilterRow': {
  '& .model-header': {
   pt: '8px !important',
  },
 },
 '& .MuiDataGrid-virtualScroller': {},
 '& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator': {},
 '& .MuiDataGrid-columnHeadersInners': {
  //    background: 'red',
 },
 '& .MuiDataGrid-columnHeaderTitle': {
  fontSize: 14,
 },
 '& .MuiDataGrid-columnSeparator': {},
 '& .MuiDataGrid-columnHeader--moving': {},

 //   '& .MuiDataGrid-columnHeader--pinnedRight, & .MuiDataGrid-scrollbarFiller.MuiDataGrid-scrollbarFiller--pinnedRight, & .MuiDataGrid-cell--pinnedRight':
 //    {
 //     background: (theme: Theme) => theme.palette.kemek.bg2,
 //    },
 '& .MuiDataGrid-cell--withLeftBorder, & .MuiDataGrid-columnHeader--withLeftBorder':
  {
   borderLeft: 0,
  },

 '& .MuiDataGrid-row': {
  cursor: 'pointer',
  //    '&.isEnabled-false': {
  //     background: props?.palette.kemek.bg2,
  //     '&:hover': {
  //      background: props?.palette.kemek.bg2,
  //     },
  //    },
  '&.Mui-selected': {
   background: 'rgba(96, 128, 255, 0.08)',
   '&:hover': {
    background: (theme: Theme) => theme.palette.kemek.lightBlue,
   },
  },
  '&.row-sidebar': {
   background: (theme: Theme) => theme.palette.kemek.bg1,
   '& .MuiDataGrid-cell--pinnedRight': {
    background: (theme: Theme) => theme.palette.kemek.bg1,
   },
   '&:hover': {
    background: (theme: Theme) => theme.palette.kemek.lightBlue,
   },
  },
  '&:hover': {
   background: (theme: Theme) => theme.palette.kemek.lightBlue,
  },
 },
 '& .MuiDataGrid-virtualScrollerContent': {
  '& .MuiDataGrid-row': {
   '&:hover': {
    '& .MuiDataGrid-cell--pinnedRight': {
     background: (theme: Theme) => theme.palette.kemek.lightBlue,
    },
   },
  },
 },
 '& .badge-item': {
  //    background: props?.palette.kemek.darkestGray,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '15px',
  px: 1,
  py: '4px',
  fontSize: 12,
 },
 '& .MuiDataGrid-pinnedRows': {
  '& .MuiDataGrid-row': {
   '&:hover': {
    background: props?.palette.kemek.white,
   },
  },
 },
 '& .MuiDataGrid-cell': {
  display: 'flex',
  alignItems: 'center',
  fontSize: 14,
  lineHeight: '25px',
  //    whiteSpace: 'normal !important',
  wordWrap: 'initial !important',
  whiteSpace: 'nowrap !important',
  padding: { xs: '8px', md: '12px' },
  overflow: 'hidden',
  //    textOverflow: 'initial',
  textOverflow: 'ellipsis',
  //   padding: 1,

  '&.MuiDataGrid-cell--editing': {
   //   padding: '4px',
  },
  '&:focus-within': {
   outline: 'none !important',
  },
 },
 '& .MuiDataGrid-detailPanel.MuiBox-root': {
  padding: 0,
  background: 'transparent',

  '& >div': {
   padding: '0 8px',
  },
 },
 '& .MuiDataGrid-columnHeader.model-header': {
  alignItems: 'flex-start',
 },
 '.MuiCheckbox-root': {
  padding: '0px',
  //    color: props?.palette.kemek.gray,
  //    '&.Mui-checked': {
  //     // color: props?.palette.kemek.gray,
  //    },
 },
 '& .MuiPaginationItem-root': {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 32,
  height: 32,
  border: `1px solid ${props?.palette.kemek.lightGray}`,
  //    '&:hover': {
  //     background: (theme: Theme) => theme.palette.kemek.lightBlue,
  //    },
  '&.Mui-selected': {
   color: props?.palette.kemek.blue,
   borderColor: props?.palette.kemek.blue,
   background: 'transparent',
   '&:hover': {
    background: (theme: Theme) => theme.palette.kemek.lightBlue,
   },
  },
 },
 '& .MuiPaginationItem-page': {
  fontSize: 12,
  //   color: '#686868',
  display: { xs: 'none', md: 'block' },
 },
 // tricky, hides block on the right when no rows displayed
 '& .MuiDataGrid-filler--pinnedRight': {
  display: 'none',
 },
 '& .MuiDataGrid-cell--pinnedRight': {
  background: (theme: Theme) => theme.palette.kemek.white,
 },
 '& .MuiDataGrid-columnHeader--pinnedRight': {
  background: (theme: Theme) => theme.palette.kemek.white,
 },
 '& .MuiDataGrid-footerContainer': {
  minHeight: { xs: 56, lg: 72 },
 },
 '& .MuiTablePagination-toolbar': {
  minHeight: 40,
  px: '20px',
 },
});
export default dataGridStyles;
